module.exports = __webpack_public_path__ + "img/Bumblebee.af8f6f54.jpg";